import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import Buttons from '../../../Litho/Components/Button/Buttons';
import CustomModal from '../../../Litho/Components/CustomModal';

const IntroOverlay = () => {
  return (
    <div className='pt-[130px] pb-[310px] overflow-hidden relative lg:pt-[95px] lg:pb-[275px] md:py-[75px] sm:py-[50px] '>
      <Parallax
        className='lg-no-parallax bg-cover absolute left-0 w-full h-full'
        translateY={[-40, 40]}
        style={{
          backgroundImage: `url(assets/img/services/our-process-bg-2.webp)`,
        }}
      ></Parallax>
      <div className='top-0 left-0 w-full h-full absolute opacity-75 bg-white'></div>
      <Container>
        <Row className='justify-center'>
          <Col md={6} className='relative lg:mx-auto sm:mb-[30px]'>
            <div className='flex items-center font-serif text-xmd font-medium mb-[30px]'>
              <span className='flex-shrink-0 w-[30px] h-[1px] bg-fastblue mr-[20px]'></span>
              <div className='flex-grow-1 text-fastblue'>
                Dependable ocean logistics
              </div>
            </div>
            <h5 className='font-serif font-medium text-darkgray m-0'>
              Reliable FCL/LCL, port-to-port and door-to-door solutions across
              major trades.
            </h5>
          </Col>
          <Col lg={5} md={6} className='lg:mx-auto relative'>
            <p className='w-[90%] mb-[45px] md:mb-[50px] xs:mb-[30px]'>
              We coordinate bookings, schedules, and documentation to keep your
              cargo flowing across ocean lanes, with proactive tracking and
              customs support.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default IntroOverlay;
